import { Navigate } from 'react-router-dom';
import { useEntity } from '@/hooks/useEntity';
import { StartupSharePreview } from '@/features/profiles/modules/startup/StartupSharePreview';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Thin container for `/startup/profile/preview`: supplies the active startup
 * and renders the feature (ADR FE-1). Falls back to the account page with no
 * entity, like `EntityProfilePage`.
 */
export function StartupProfilePreviewPage() {
  const entity = useEntity();
  if (!entity) return <Navigate to={ROUTES.ACCOUNT} replace />;
  return <StartupSharePreview entityId={entity.entityId} />;
}
